export default __webpack_public_path__ + "fonts/Gotham-Bold.e9cec78c3bdbd487c6c83ef77c5ae0cb.otf";